var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5468_3487)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 18,
    fill: "#E7F6ED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7676 31H9.23188C8.55159 31 8 31.6716 8 32.5C8 33.3284 8.55159 34 9.23188 34H30.7681C31.4484 34 32 33.3284 32 32.5C32 31.6716 31.4479 31 30.7676 31Z",
    fill: "url(#paint0_linear_5468_3487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0404 12.9043C32.8829 12.9043 31.945 13.8423 31.945 14.9997C31.945 15.5797 32.1807 16.1044 32.5611 16.4837L26.0512 19.9398L20.9408 10.3653C21.7612 10.023 22.3381 9.21415 22.3381 8.26992C22.3381 7.01634 21.3217 6 20.0681 6C18.8146 6 17.7982 7.01634 17.7982 8.26992C17.7982 9.21415 18.3751 10.0236 19.1955 10.3653L14.085 19.9398L7.57523 16.4837C7.95564 16.1044 8.1913 15.5797 8.1913 14.9997C8.1913 13.8423 7.25334 12.9043 6.09591 12.9043C4.93848 12.9043 4 13.8423 4 14.9997C4 16.1572 4.93796 17.0951 6.09539 17.0951C6.14503 17.0951 6.19415 17.0909 6.24327 17.0878L8.63623 29H31.5288L33.893 17.0878C33.9421 17.0915 33.9907 17.0951 34.0409 17.0951C35.1983 17.0951 36.1363 16.1572 36.1363 14.9997C36.1363 13.8423 35.1978 12.9043 34.0404 12.9043Z",
    fill: "url(#paint1_linear_5468_3487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9573 25.7548C19.5226 25.7548 19.0718 25.6985 18.6048 25.5858C18.1379 25.4731 17.7314 25.304 17.3852 25.0786C17.2242 24.9739 17.1155 24.8532 17.0592 24.7163C17.0028 24.5795 16.9867 24.4507 17.0109 24.3299C17.0431 24.2011 17.1034 24.0924 17.192 24.0039C17.2886 23.9153 17.4053 23.863 17.5422 23.8469C17.6871 23.8308 17.8441 23.867 18.0131 23.9556C18.3432 24.1327 18.6612 24.2615 18.9671 24.342C19.273 24.4144 19.587 24.4507 19.909 24.4507C20.2632 24.4507 20.5611 24.4024 20.8026 24.3057C21.0441 24.2091 21.2253 24.0642 21.346 23.871C21.4748 23.6778 21.5392 23.4444 21.5392 23.1706C21.5392 22.7681 21.4024 22.4703 21.1287 22.277C20.863 22.0758 20.4725 21.9752 19.9573 21.9752H19.1845C18.9591 21.9752 18.786 21.9188 18.6652 21.8061C18.5525 21.6934 18.4962 21.5364 18.4962 21.3351C18.4962 21.1339 18.5525 20.9769 18.6652 20.8642C18.786 20.7515 18.9591 20.6951 19.1845 20.6951H19.8124C20.1183 20.6951 20.38 20.6468 20.5973 20.5502C20.8147 20.4456 20.9837 20.3007 21.1045 20.1155C21.2253 19.9304 21.2856 19.7049 21.2856 19.4393C21.2856 19.069 21.1609 18.7872 20.9113 18.594C20.6698 18.4008 20.3156 18.3042 19.8486 18.3042C19.5508 18.3042 19.269 18.3404 19.0033 18.4128C18.7457 18.4773 18.4599 18.602 18.146 18.7872C18.0011 18.8757 17.8602 18.912 17.7233 18.8959C17.5945 18.8798 17.4858 18.8274 17.3973 18.7389C17.3087 18.6503 17.2484 18.5457 17.2162 18.4249C17.184 18.2961 17.192 18.1673 17.2403 18.0385C17.2886 17.9016 17.3892 17.7849 17.5422 17.6883C17.8884 17.4629 18.2708 17.2938 18.6894 17.1811C19.108 17.0604 19.5387 17 19.9815 17C20.5692 17 21.0723 17.0926 21.4909 17.2777C21.9095 17.4548 22.2275 17.7125 22.4449 18.0506C22.6703 18.3806 22.783 18.7832 22.783 19.2581C22.783 19.5963 22.7186 19.9062 22.5898 20.188C22.461 20.4617 22.2799 20.6951 22.0464 20.8883C21.8129 21.0816 21.5312 21.2184 21.2011 21.2989V21.154C21.7807 21.2506 22.2316 21.4921 22.5536 21.8785C22.8756 22.2569 23.0366 22.7319 23.0366 23.3035C23.0366 23.8026 22.9118 24.2373 22.6623 24.6076C22.4127 24.978 22.0585 25.2637 21.5996 25.465C21.1407 25.6582 20.5933 25.7548 19.9573 25.7548Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5468_3487",
    x: 0,
    y: 2,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5468_3487"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5468_3487",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5468_3487",
    x1: 20,
    y1: 31,
    x2: 20,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#66CF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7475,
    stopColor: "#61CB77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB46B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5468_3487",
    x1: 20.0681,
    y1: 6,
    x2: 20.0681,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ED453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#66CF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7475,
    stopColor: "#61CB77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB46B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3);
export default __webpack_public_path__ + "static/media/level3.eac2c02e04ea360376771c470c060e54.svg";
export { ForwardRef as ReactComponent };